'use strict';
import React from 'react';
import flux from 'utils/flux';
import {Link} from 'react-router';

var HeaderMinimal = React.createClass({

    displayName: 'HeaderMinimal',

    logout(e) {
        e.preventDefault();
        flux.getActions('app').logout();
        this.context.router.transitionTo('login');
    },

    render() {
        return (
            <div className="header--inner">
                <Link to="login" className="header__logo">
                    <div className="logo__image" />
                    <div className="logo__divider"></div>
                    <div className="logo__title">
                        <h4>{flux.t('header_title')}</h4>
                    </div>
                </Link>
                <a href="#" className="header__login" onClick={this.logout}>
                    {flux.t('logout')}
                    <i/>
                </a>
            </div>
        );
    }
});

module.exports = HeaderMinimal;



// WEBPACK FOOTER //
// ./app/components/header/headerMinimal.jsx